exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pdf-document .final-proposal{font-size:.75rem}.small-font{font-size:.75rem}.medium-font{font-size:1rem}.large-font{font-size:1.5rem}.pdf-document .final-proposal h2{font-size:1.5rem}.pdf-document .final-proposal h5,.pdf-document .final-proposal .lead{font-size:1rem}.page-break-before{page-break-before:always}.page-break-after{page-break-after:always}@page{margin:0;padding:0;size:letter}@media print{body{margin:0;padding:0;background-color:#fff;size:letter}a{color:#000}.text-secondary{color:#000 !important}}.DateInput_screenReaderMessage{display:none}.section-size{page-break-inside:avoid;page-break-after:auto}.section-size-debug{position:absolute;background:#4682b4;z-index:100000;color:#fff;font-size:14px;padding:.25rem .5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/proposal/pdf.scss
// module id = 6504
// module chunks = 0